/**
 * KAN-835: уведомления менеджера в приложении (/m/profile, блок "Уведомления").
 *
 *   GET    /api/v1/managers/me/push/          - статус: {public_key, subscribed, telegram_linked,
 *                                                bot_connected, bot_username}
 *   POST   /api/v1/managers/me/push/          - {endpoint, keys: {p256dh, auth}} подписка устройства;
 *                                                ответ как у GET
 *   DELETE /api/v1/managers/me/push/          - {endpoint} отписка устройства (204)
 *   POST   /api/v1/managers/me/telegram-link/ - {url, expires_at} ссылка привязки своего Telegram;
 *                                                400 {detail}, если бот платформы не подключён
 *   DELETE /api/v1/managers/me/telegram/      - отвязать свой Telegram (204)
 *
 * Только своя запись менеджера; у входа без записи 404.
 */
import apiClient from './client';

const PUSH = '/api/v1/managers/me/push/';
const TELEGRAM_LINK = '/api/v1/managers/me/telegram-link/';
const TELEGRAM = '/api/v1/managers/me/telegram/';

export interface ManagerNotificationsStatus {
  public_key: string;
  /** У менеджера есть подписка хотя бы на одном устройстве. */
  subscribed: boolean;
  telegram_linked: boolean;
  bot_connected: boolean;
  bot_username: string | null;
}

export interface PushSubscriptionBody {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export interface TelegramLink {
  url: string;
  expires_at: string;
}

export const managerNotificationsApi = {
  getStatus: async (): Promise<ManagerNotificationsStatus> =>
    (await apiClient.get<ManagerNotificationsStatus>(PUSH)).data,
  subscribe: async (body: PushSubscriptionBody): Promise<ManagerNotificationsStatus> =>
    (await apiClient.post<ManagerNotificationsStatus>(PUSH, body)).data,
  unsubscribe: async (endpoint: string): Promise<void> => {
    await apiClient.delete(PUSH, { data: { endpoint } });
  },
  telegramLink: async (): Promise<TelegramLink> => (await apiClient.post<TelegramLink>(TELEGRAM_LINK)).data,
  telegramUnlink: async (): Promise<void> => {
    await apiClient.delete(TELEGRAM);
  },
};
